import './index.css'
import React from 'react'
import FlexColumn from 'components/FlexColumn'
import Flex from 'components/Flex'
import VerticalSeparator from 'components/VerticalSeparator'
import TextSemiBold from 'components/TextSemiBold'
import Span from 'components/Span'
import useSelector from 'hooks/use-selector'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import useDispatch from 'hooks/use-dispatch'
import logUtil from 'utils/log'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'
import sanitizeOptionValue from 'containers/QuickShopProductSidebar/components/ColorSwatches/util/sanitize-option-value'
import getVariantUtil from 'modules/product/redux/selectors/get-variant-by-id/utils/get-variant'
import getByVariantIdDeepProductSelector from 'modules/product/redux/selectors/get-by-variant-id-deep'

import QuickShopProductSidebarColorSwatchesList from 'containers/QuickShopProductSidebar/components/ColorSwatches/components/List'
import uniqArrayUtil from 'utils/array/uniq'

const COLOR = 'Color'

export default function QuickShopProductSidebarColorSwatches (props) {
  const dispatch = useDispatch()
  /**
   * @type {ProductVariantCollection}
   */
  const productVariant = props.productVariant

  const fullSizeVariant = useSelector(
    getByVariantIdDeepProductSelector(productVariant?.variant_id)
  )
  const sampleVariant = useSelector(
    getByVariantIdDeepProductSelector(productVariant?.variant_id)
  )

  let selectedProductVariant = productVariant
  if (getVariantUtil(fullSizeVariant, productVariant.variant_id)) {
    selectedProductVariant = fullSizeVariant
  }
  if (getVariantUtil(sampleVariant, productVariant.variant_id)) {
    selectedProductVariant = sampleVariant
  }

  const variants = (
    getVariantsProductVariantUtil(selectedProductVariant)
  )

  const selectedVariant = useSelector(getSelectedVariantSelect)

  const hasColor = /color/gi.test(productVariant.option_name)

  const allVariants = uniqArrayUtil([
    productVariant,
    ...variants
  ], (variant) => {
    return variant.variant_id
  })

  // other variants: all the variants whose price
  // differ than the price of selected variant is considered as
  // other variant
  const otherVariants = selectedVariant
    ? allVariants?.filter((variant) => {
      return variant?.price !== selectedVariant?.price
    })
    : []

  const debugProps = {
    props,
    productVariant,
    variants,
    hasColor,
    selectedVariant,
    otherVariants,
    sampleVariant,
    selectedProductVariant,
    fullSizeVariant,
    allVariants
  }
  logUtil('QuickShopProductSidebarColorSwatches').debug('[start] debugProps=', debugProps)

  const handleUnmount = () => {
    logUtil('QuickShopProductSidebarColorSwatches#handleUnmount').debug('[start]')
    dispatch(updateSelectedColorVariantIdVariantAction())
  }

  React.useEffect(() => {
    return handleUnmount
  }, [])

  // if there is only one variant then we don't need to show the color swatches
  if (allVariants?.length - otherVariants?.length <= 1) {
    return <></>
  }

  // if (allVariants?.length <= 1) {
  //   return <></>
  // }

  return (
    <FlexColumn className='quick-shop-product-sidebar-color-swatches'>
      <Flex className='quick-shop-product-sidebar-color-swatches-title'>
        <TextSemiBold className='quick-shop-product-sidebar-color-swatches-title-label'>
          {COLOR}
        </TextSemiBold>
        <VerticalSeparator />
        <Span className='quick-shop-product-sidebar-color-swatches-title-value'>
          {sanitizeOptionValue(selectedVariant?.option_value)}
        </Span>
      </Flex>

      <QuickShopProductSidebarColorSwatchesList
        allVariants={allVariants}
        otherVariants={otherVariants}
        selectedVariant={selectedVariant}
      />
    </FlexColumn>
  )
}
